import { getPastWMTWeekDateRange, getWMTWeekToDate } from '../../helper/date';

const getFormattedDate = (_d, fmt = 'MMM DD') => {
	if (!_d) {
		return '';
	}
	return `${_d.format(fmt)}`;
};

const getDateRange = (index, value, startWeek, endWeek, start, end) => {
	let showYear = '';
	if (startWeek) {
		showYear =
			start?.format('YYYY') === end?.format('YYYY')
				? ''
				: `, ${start?.format('YYYY')}`;
	}

	if (value === 'Custom') {
		return startWeek
			? `${value} (${getFormattedDate(start)}${showYear} - ${getFormattedDate(
					end
			  )}, ${end?.format('YYYY')})`
			: `${value}`;
	}

	const { startDate, endDate } = +index
		? getPastWMTWeekDateRange(index)
		: getWMTWeekToDate();

	if (startDate?.slice(-4) === endDate?.slice(-4)) {
		return `${value} (${startDate?.substring(
			0,
			startDate?.length - 6
		)} - ${endDate})`;
	}
	return `${value} (${startDate} - ${endDate})`;
};

const hierarchy = [
	{
		//Department Level
		level: 0,
		id: 31,
		name: 'D32 - Jewelry',
		parentId: null,
		nestedId: '31',
		categories: [
			{
				//Category Level
				level: 1,
				id: 928,
				name: 'Watches',
				parentId: 31,
				nestedId: '31_928',
				subcategories: [
					{
						//Sub-Categories Level
						level: 3,
						id: 16928,
						name: 'Watch Bands',
						parentId: 928,
						nestedId: '31_928_16928',
					},
					{
						level: 3,
						id: 16929,
						name: 'Watch Batteries',
						parentId: 928,
						nestedId: '31_928_16929',
					},
				],
			},
		],
	},
	{
		//Department Level
		level: 0,
		id: 32,
		name: 'D32 - Jewelry',
		parentId: null,
		nestedId: '32',
		categories: [
			{
				//Category Level
				level: 1,
				id: 928,
				name: 'Watches',
				parentId: 32,
				nestedId: '32_928',
				subcategories: [
					{
						//Sub-Categories Level
						level: 3,
						id: 1628,
						name: 'Watch Bands',
						parentId: 928,
						nestedId: '32_928_16928',
					},
					{
						level: 3,
						id: 1629,
						name: 'Watch Batteries',
						parentId: 928,
						nestedId: '32_928_16929',
					},
				],
			},
		],
	},
];

// O(n*m) complexity
// n: no of departments
// m: no of categories
const generalizeTreeStructure = (departments) => {
	let newDepartment = JSON.parse(JSON.stringify(departments));
	newDepartment.forEach((department) => {
		department.subHierarchy = department?.categories;
		department?.categories?.forEach((category) => {
			category.subHierarchy = category?.subcategories;
			delete category.subcategories;
		});
		delete department.categories;
	});
	return newDepartment;
};

const parseToDepartment = (hierarchy) => {
	let newHierarchy = JSON.parse(JSON.stringify(hierarchy));
	newHierarchy.forEach((department) => {
		department.categories = department?.subHierarchy;
		department?.subHierarchy?.forEach((category) => {
			category.subcategories = category?.subHierarchy;
			delete category.subHierarchy;
		});
		delete department.subHierarchy;
	});
	return newHierarchy;
};

const getWeekFilterDateRange = ({
	weekFilter,
	startDateInput = '',
	endDateInput = '',
}) => {
	if (weekFilter === -1) {
		return {
			startDate: startDateInput,
			endDate: endDateInput,
		};
	}
	const format = 'YYYY-MM-DD';
	const { startDate, endDate } =
		weekFilter === 0
			? getWMTWeekToDate(format)
			: getPastWMTWeekDateRange(weekFilter, format);
	return {
		startDate,
		endDate,
	};
};

export {
	getDateRange,
	getFormattedDate,
	generalizeTreeStructure,
	getWeekFilterDateRange,
	parseToDepartment,
	hierarchy,
};
